import script from "./ErrorMsg.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorMsg.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorMsg.vue?vue&type=style&index=0&id=ab049a02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab049a02"]])

export default __exports__